<app-page-header [header]="getPageHeader()" [showBackButton]="false" />
<app-surgeries-citizen-list />